import React from 'react';
import { Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';
import logoName from "../../../asset/svg/SidebarLogoName.svg";
import logo from "../../../asset/svg/SidebarLogo.svg";
import coinsWon from '../../../asset/svg/coinsWon.svg';
import downArrow from '../../../asset/svg/downArrow.svg';
import UserProfile from '../../../asset/svg/UserProfile.svg'
import { Typography } from '@mui/material';
import { useLocation, } from "react-router-dom";

const useStyles = createUseStyles((theme) => ({
    container: {
        marginRight: 32,
        padding: '1rem 1rem 1rem 0.8rem'
    },
    container2: {
        marginRight: 32,
        padding: '1rem 1rem 1rem 0.8rem'
    },
    title: {
        ...theme.typography.cardTitle,
        opacity: 0.7,
        marginLeft: 12
    }
}));

function LogoComponent() {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const { pathname } = useLocation();
    return (
        <div>
            <Row className={classes.container} horizontal='center' vertical='center'>
                <img src={logo} alt="" />&nbsp;&nbsp;&nbsp;
                <span ><img src={logoName} alt="" /></span>
            </Row>
            {/* {pathname && pathname == '/home' && <Row className={classes.container2} horizontal='center' vertical='center'>
                <img src={UserProfile} alt="" />&nbsp;&nbsp;&nbsp;
                <span style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ display: 'flex' }}>
                        <Typography color='#FFFFFF'>Karthick Raja</Typography> &nbsp; &nbsp;<img src={downArrow} alt='' />
                    </span>
                    <span >
                        <img src={coinsWon} alt='' />
                    </span>
                </span>

            </Row>} */}
        </div>
    );
}

export default LogoComponent;
